import { FC } from "react";

interface GoogleLogoSVGProps {
    className?: string;
}

const GoogleLogoSVG: FC<GoogleLogoSVGProps> = (props) => {
    return (
        <svg
            className={props.className}
            width="37"
            height="37"
            viewBox="0 0 37 37"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
        >
            <g clipPath="url(#clip0_196_14855)">
                <mask
                    id="mask0_196_14855"
                    style={{ maskType: "luminance" }}
                    maskUnits="userSpaceOnUse"
                    x="0"
                    y="0"
                    width="37"
                    height="37"
                >
                    <path d="M36.5 0.5H0.5V36.5H36.5V0.5Z" fill="white" />
                </mask>
                <g mask="url(#mask0_196_14855)">
                    <path
                        d="M36.4779 18.8353C36.4779 17.3604 36.3555 16.2841 36.0904 15.168H18.8555V21.8249H28.972C28.7681 23.4793 27.6667 25.9707 25.2191 27.6448L25.1848 27.8677L30.6342 31.993L31.0117 32.0298C34.479 28.9006 36.4779 24.2964 36.4779 18.8353Z"
                        fill="#4285F4"
                    />
                    <path
                        d="M18.8558 36.3747C23.812 36.3747 27.9728 34.7802 31.012 32.0297L25.2194 27.6447C23.6693 28.7011 21.5888 29.4386 18.8558 29.4386C14.0015 29.4386 9.88141 26.3094 8.41273 21.9844L8.19746 22.0022L2.53113 26.2875L2.45703 26.4888C5.47566 32.3485 11.6762 36.3747 18.8558 36.3747Z"
                        fill="#34A853"
                    />
                    <path
                        d="M8.4137 21.9843C8.02618 20.8681 7.80191 19.6721 7.80191 18.4365C7.80191 17.2007 8.02618 16.0048 8.39331 14.8887L8.38305 14.651L2.64572 10.2969L2.458 10.3841C1.21388 12.8158 0.5 15.5464 0.5 18.4365C0.5 21.3265 1.21388 24.057 2.458 26.4886L8.4137 21.9843Z"
                        fill="#FBBC05"
                    />
                    <path
                        d="M18.8558 7.43604C22.3027 7.43604 24.6278 8.89102 25.9536 10.1069L31.1343 5.16392C27.9526 2.27389 23.812 0.5 18.8558 0.5C11.6762 0.5 5.47566 4.52609 2.45703 10.3858L8.39234 14.8904C9.8814 10.5653 14.0015 7.43604 18.8558 7.43604Z"
                        fill="#EB4335"
                    />
                </g>
            </g>
            <defs>
                <clipPath id="clip0_196_14855">
                    <rect width="36" height="36" fill="white" transform="translate(0.5 0.5)" />
                </clipPath>
            </defs>
        </svg>
    );
};

export default GoogleLogoSVG;
